module.exports = __webpack_public_path__ + "static/img/Northern-Ireland-BTR-Loft-Lines.e875d484.jpg";